import http, { API_CORE } from '../../http';

/**
 * Product Tag Service for V2 API
 * All methods use /v2/tags endpoints
 */
export default function ProductTagServiceV2() {
  const list = async (params) => {
    const response = await http(API_CORE).get('/v2/tags', { params });
    return response.data;
  };

  const getBySlug = async (slug) => {
    const response = await http(API_CORE).get(`/v2/tags/${slug}`);
    return response.data.tag;
  };

  const getDetail = async (slug) => {
    const response = await http(API_CORE).get(`/v2/tags/${slug}/detail`);
    return response.data;
  };

  const create = async ({ slug }) => {
    const response = await http(API_CORE).post('/v2/tags', { slug });
    return response.data.tag;
  };

  const update = async ({ id, slug }) => {
    const response = await http(API_CORE).patch(`/v2/tags/${id}`, { slug });
    return response.data.tag;
  };

  const remove = async (id) => {
    const response = await http(API_CORE).delete(`/v2/tags/${id}`);
    return response.data;
  };

  return {
    list,
    getBySlug,
    getDetail,
    create,
    update,
    remove,
  };
}
